import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56e146ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, " We serve cookies on this site to analyze traffic, remember your preferences, and optimize your experience. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog_transition = _resolveComponent("v-dialog-transition")!

  return (_openBlock(), _createBlock(_component_v_dialog_transition, null, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            title: "Cookie Preference",
            class: "cookie-card",
            color: "primary",
            tile: "",
            elevation: "5"
          }, {
            text: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  class: "mx-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navToCookies()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Disagree ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enableCookies()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Agree ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}